import { render, staticRenderFns } from "./MailboxDialog.vue?vue&type=template&id=ddb4b9da&scoped=true&"
import script from "./MailboxDialog.vue?vue&type=script&lang=js&"
export * from "./MailboxDialog.vue?vue&type=script&lang=js&"
import style0 from "./MailboxDialog.vue?vue&type=style&index=0&id=ddb4b9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb4b9da",
  null
  
)

export default component.exports